<template>
    <div id="forgot-password-page">

        <!-- White Box Section -->
        <section class="section-style margin-top-120">
            <div class="container padding-right-left-0">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-6">
                        <div class="box-form bg-white box-shadow rounded">
                            <h1 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Reset password</h1>
                            <p v-if="emailSent">We've sent instructions on how to reset your password to your email address.</p>
                            <form action="" @submit="onSubmit($event)" v-if="!emailSent">
                                <div class="row">
                                    <div class="col form-group">
                                        <label class="font-sm" for="email">Email Address</label>
                                        <i class="material-icons">email</i>
                                        <input id="email" name="email" type="text" class="form-control input-style"
                                                aria-describedby="Email address"
                                                v-model="form.email"
                                                :disabled="loading">
                                        <p class="help text-danger margin-0" v-if="$v.form.email.$error">You have to provide a valid email.</p>
                                    </div>
                                </div>
                                <div class="row margin-top-20 margin-bottom-20 justify-content-center">
                                    <div class="col-auto">
                                        <button class="btn btn-primary btn-lg text-uppercase">
                                            <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Reset Password
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import {validationMixin} from "vuelidate";
    import {required, email} from "vuelidate/lib/validators";

    export default {
        mixins: [validationMixin],
        components: {},
        data() {
            return {
                loading: false,
                emailSent: false,
                form: {
                    email: ''
                }
            }
        },
        methods: {
            async onSubmit(e) {
                e.preventDefault();

                if (this.$v.form.$invalid)
                    this.$v.form.$touch();

                this.loading = true;

                const response = await this.$httpClient.request('post', '/api/actions/send-reset-password-token', this.form);

                if (response.status === 'OK')
                    this.emailSent = true;

                this.loading = false;
            }
        },
        validations: {
            form: {
                email: {
                    required,
                    email
                }
            }
        }
    }

</script>

<style lang="scss">
    .form {
        padding: 35px
    }
</style>